import { FC, ReactNode } from 'react';
import {
  analyticsSectionBackgroundStyle,
  analyticsSectionOuterClassName,
} from 'app/modules/analytics/config/analyticsConfig';

interface Props {
  title: string;
  children: ReactNode;
}

const ReportPreviewSectionBlock: FC<Props> = ({ title, children }) => (
  <div
    className={`${analyticsSectionOuterClassName} analytics-report-section-block`}
    style={analyticsSectionBackgroundStyle}
  >
    <div className="tw-flex tw-items-center tw-px-4">
      <h3 className="tw-text-base tw-font-semibold tw-text-grayscale-180">
        {title}
      </h3>
    </div>
    <div className="tw-flex tw-flex-col tw-gap-1 tw-py-4">{children}</div>
  </div>
);

export default ReportPreviewSectionBlock;
